import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "splash-page",
  class: "splash"
}
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "text-xs-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createElementVNode("h1", null, "AgeWage", -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-5" }, [
              _createElementVNode("h1", { class: "mb-3 font-weight-light" }, " Page not found :( "),
              _createElementVNode("p", null, "Looks like you have followed a broken link.")
            ], -1)),
            _createVNode(_component_v_btn, {
              to: { name: 'index' },
              exact: "",
              text: "",
              small: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { left: "" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" fa-long-arrow-alt-left ", -1)
                  ]))]),
                  _: 1
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "Back to Homepage", -1))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}